import { useStateSelector } from "utils/field";
import { isSubcomponentDirectionLocked } from "utils/enclosure/components";

/** Whether a subcomponent's facingDirection field should be read-only (inherited from wall or door). */
export const useSubcomponentDirectionLocked = (_componentType, _accessor, parentAccessor) => {
    const mainCompAccessor = parentAccessor?.split(".subcomponents")[0] || "";
    const { id: mainCompFacingId } = useStateSelector(`${mainCompAccessor}.facingDirection`) || {};
    const { id: parentFacingId } = useStateSelector(`${parentAccessor}.facingDirection`) || {};

    return isSubcomponentDirectionLocked(_componentType, {
        mainCompFacingId,
        parentFacingId,
        isDoorWindow: _componentType === "window" && mainCompAccessor !== parentAccessor,
    });
};
